/**
 * Returns an arbitrary element from the set, or undefined if the set is empty.
 *
 * @param set - The set to get an element from.
 * @returns An arbitrary element from the set, or undefined if the set is empty.
 */
export function anyElement<T>(set: Set<T>): T | undefined {
  return set.values().next().value;
}
